import type { PositionHandler } from 'hb-builder/components/BuilderComponents/single/PageImage/types';

import { isHorizontalHandler, isVerticalHandler } from './helpers';

export const getCursor = ({
  $position,
}: {
  $position: PositionHandler;
}): string | undefined => {
  if ($position.startsWith('corner')) {
    const [, first, second] = $position.split('-');

    if (
      (first === 'top' && second === 'left') ||
      (first === 'bottom' && second === 'right')
    ) {
      return `
        cursor: nwse-resize;
      `;
    }

    if (
      (first === 'bottom' && second === 'left') ||
      (first === 'top' && second === 'right')
    ) {
      return `
        cursor: nesw-resize;
      `;
    }
  }

  if (isHorizontalHandler($position)) {
    return `
      cursor: ew-resize;
    `;
  }

  if (isVerticalHandler($position)) {
    return `
      cursor: ns-resize;
    `;
  }
};

export const getGlobalPosition = ({
  $position,
}: {
  $position: PositionHandler;
}): string | undefined => {
  if ($position.startsWith('corner')) {
    const [, first, second] = $position.split('-');

    return `
      ${first}: 0;
      ${second}: 0;
    `;
  }

  if (isHorizontalHandler($position)) {
    return `
      ${$position}: 0;
      bottom: 50%;
    `;
  }

  if (isVerticalHandler($position)) {
    return `
      ${$position}: 0;
      right: 50%;
    `;
  }
};
